export default () => ({
  description: "",
  contractIds: [],
  userIds: [],
  partnerId: null,
});
